import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ButtonBase, Typography, Stack } from 'investira.react.components';

/**
 * Renderiza o componente TextActionButton.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {boolean} props.disabled - Indica se o componente deve ser desabilitado.
 * @param {React.ReactNode} props.children - Conteúdo renderizado dentro do componente.
 * @param {Object} props.restProps - Props adicionais repassadas para `restProps`.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const TextActionButton = memo(({ children, ...restProps }) => {
    return (
        <ButtonBase {...restProps} color={'primary'}>
            <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                    width: '48px',
                    height: '48px'
                }}>
                <Typography
                    variant={'body1'}
                    color={restProps.disabled ? 'text.secondary' : 'primary'}
                    sx={{ lineHeight: 'unset' }}>
                    {children || 'OK'}
                </Typography>
            </Stack>
        </ButtonBase>
    );
});

TextActionButton.displayName = 'TextActionButton';

TextActionButton.propTypes = {
    disabled: PropTypes.bool
};

TextActionButton.defaultProps = {
    disabled: false
};

export default TextActionButton;
